import {
  type FunctionComponent,
  type ReactNode,
  createContext,
  useContext,
  useMemo,
} from 'react';
import { useSelector } from 'react-redux';

import { selectors } from 'store';

import { CombinedEnrolment, combineEnrolmentData } from './helpers';

export interface RateRequestListContextType {
  isLoading: boolean;
  combined: CombinedEnrolment[];
}

export const RateRequestListContext = createContext<RateRequestListContextType>(
  {
    isLoading: false,
    combined: [],
  },
);

export const useRateRequestListContext = () =>
  useContext(RateRequestListContext);

export interface RateRequestListProviderProps {
  children: ReactNode;
}

const RateRequestListProvider: FunctionComponent<RateRequestListProviderProps> =
  function ({ children }) {
    const enrolments = useSelector(selectors.enrolment.getEntitiesAsArray);
    const enrolmentsIsLoading = useSelector(selectors.enrolment.getIsLoading);

    const companies = useSelector(selectors.company.getEntities);
    const companiesIsLoading = useSelector(selectors.company.getIsLoading);

    const isLoading = useMemo(
      () => enrolmentsIsLoading || companiesIsLoading,
      [enrolmentsIsLoading, companiesIsLoading],
    );

    const combined = useMemo(() => {
      if (isLoading || enrolments.length === 0 || !companies) return [];
      return combineEnrolmentData(enrolments, companies);
    }, [isLoading, enrolments, companies]);

    const values = useMemo(
      () => ({
        isLoading,
        combined,
      }),
      [isLoading, combined],
    );

    console.log({ values });

    return (
      <RateRequestListContext.Provider value={values}>
        {children}
      </RateRequestListContext.Provider>
    );
  };

export default RateRequestListProvider;
